import { render, staticRenderFns } from "./parsingtzbs.vue?vue&type=template&id=297fce69&scoped=true&"
import script from "./parsingtzbs.vue?vue&type=script&lang=js&"
export * from "./parsingtzbs.vue?vue&type=script&lang=js&"
import style0 from "./parsingtzbs.vue?vue&type=style&index=0&id=297fce69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297fce69",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('297fce69')) {
      api.createRecord('297fce69', component.options)
    } else {
      api.reload('297fce69', component.options)
    }
    module.hot.accept("./parsingtzbs.vue?vue&type=template&id=297fce69&scoped=true&", function () {
      api.rerender('297fce69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/physical/parsingtzbs.vue"
export default component.exports